import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileP2pPaymentMethods.css';

interface PaymentMethod {
  id: string;
  initials: string;
  accountName: string;
  bankName: string;
  accountNumber: string;
}

interface PaymentMethodCardProps {
  paymentMethod: PaymentMethod;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

const ProfileP2pPaymentMethods: React.FC = () => {
  const navigate = useNavigate();

  // Mock payment methods data
  const paymentMethods: PaymentMethod[] = [
    {
      id: '1',
      initials: 'Ze',
      accountName: 'Dayo\nOdewade',
      bankName: 'ZenithBank',
      accountNumber: '4234626128'
    },
    {
      id: '2',
      initials: 'Mo',
      accountName: 'Dayo\nOdewade',
      bankName: 'MoniePoint',
      accountNumber: '8034765716'
    },
    {
      id: '3',
      initials: 'OP',
      accountName: 'Dayo\nOdewade',
      bankName: 'OPay',
      accountNumber: '8034765716'
    }
  ];

  const handleEdit = (id: string) => {
    console.log('Edit payment method:', id);
    // Mock edit logic
  };

  const handleDelete = (id: string) => {
    console.log('Delete payment method:', id);
    // Mock delete logic
  };

  const handleAddNew = () => {
    console.log('Add new payment method');
    // Mock add new logic
  };

  const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({ 
    paymentMethod, 
    onEdit, 
    onDelete 
  }) => (
    <div className="p2p-payment-card">
      <div className="p2p-payment-card-content">
        <div className="p2p-payment-avatar">
          <span className="p2p-payment-avatar-text">{paymentMethod.initials}</span>
        </div>
        <div className="p2p-payment-info">
          <h3 className="p2p-payment-name">{paymentMethod.accountName}</h3>
          <p className="p2p-payment-bank">{paymentMethod.bankName}</p>
          <p className="p2p-payment-account">{paymentMethod.accountNumber}</p>
        </div>
        <div className="p2p-payment-actions">
          <button 
            className="p2p-payment-action-button"
            onClick={() => onEdit(paymentMethod.id)}
            aria-label="Edit payment method"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M11.3333 2.00004C11.5084 1.82494 11.7163 1.68605 11.9451 1.59129C12.1738 1.49653 12.419 1.44775 12.6666 1.44775C12.9143 1.44775 13.1595 1.49653 13.3882 1.59129C13.617 1.68605 13.8249 1.82494 14 2.00004C14.1751 2.17513 14.314 2.383 14.4087 2.61178C14.5035 2.84055 14.5523 3.08575 14.5523 3.33337C14.5523 3.58099 14.5035 3.82619 14.4087 4.05497C14.314 4.28374 14.1751 4.49161 14 4.66671L5.00001 13.6667L1.33334 14.6667L2.33334 11L11.3333 2.00004Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button 
            className="p2p-payment-action-button"
            onClick={() => onDelete(paymentMethod.id)}
            aria-label="Delete payment method"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M2 4H3.33333H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5.33333 4V2.66667C5.33333 2.31304 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31304 1.33333 6.66667 1.33333H9.33333C9.68696 1.33333 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31304 10.6667 2.66667V4M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.687 14.6667 11.3333 14.6667H4.66667C4.31304 14.6667 3.97391 14.5262 3.72386 14.2761C3.47381 14.0261 3.33333 13.687 3.33333 13.3333V4H12.6667Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="p2p-payment-container">
      {/* Header */}
      <div className="p2p-payment-header">
        <button className="p2p-payment-back-button" onClick={() => navigate('/profile')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="p2p-payment-header-title">P2P Payment Methods</h1>
      </div>

      {/* Payment Methods List */}
      <div className="p2p-payment-list">
        {paymentMethods.map((method, index) => (
          <React.Fragment key={method.id}>
            <PaymentMethodCard
              paymentMethod={method}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
            {index < paymentMethods.length - 1 && (
              <div className="p2p-payment-divider" />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Add New Payment Method Button */}
      <button className="p2p-payment-add-button" onClick={handleAddNew}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 3.33333V12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3.33333 8H12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span>Add a new payment method</span>
      </button>
    </div>
  );
};

export default ProfileP2pPaymentMethods;